import Product from "./Product";

class User {
  id;
  role;
  name;
  image;
  phone;
  savedProducts;
  isAlreadyContactedByAdmin;

  constructor(data) {
    this.init(data);
  }

  //initialize the user
  init(data) {
    const {
      id,
      role,
      name,
      image,
      phone,
      savedProducts,
      isAlreadyContactedByAdmin,
    } = data;

    if (!id || !name || !image || !phone || role !== 0)
      throw new Error("Invalid user data");

    const allSavedProducts = savedProducts.length
      ? savedProducts.map((p) => new Product(p))
      : [];

    this.id = id;
    this.role = role;
    this.name = name;
    this.image = image;
    this.phone = phone;
    this.isAlreadyContactedByAdmin = isAlreadyContactedByAdmin;
    this.savedProducts = [...allSavedProducts];
  }

  //somes getters
  get getId() {
    return this.id;
  }

  get getRole() {
    return this.role;
  }

  get getName() {
    return this.name;
  }

  get getImage() {
    return this.image;
  }

  get getPhone() {
    return this.phone;
  }

  get getSavedProducts() {
    return this.savedProducts;
  }

  get getIsContacted() {
    return this.isAlreadyContactedByAdmin;
  }
}

export default User;
